
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'axis-components/components/card/card.module';
import { ButtonsModule } from 'axis-components/components/button/button.module';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { GatewayTimeoutComponent } from './gateway-timeout/gateway-timeout.component';
import { ServiceUnavailableComponent } from './service-unavailable/service-unavailable.component';
@NgModule({
  declarations: [
    PageNotFoundComponent,
    GatewayTimeoutComponent,
    ServiceUnavailableComponent,
    UnauthorizedComponent
  ],
  imports: [
    CommonModule,
    ButtonsModule,
    CardModule
  ],
  exports: [
    UnauthorizedComponent,
    PageNotFoundComponent,
    GatewayTimeoutComponent,
    ServiceUnavailableComponent
  ]
})
export class CommonErrorsModule { }
